<template>
  <DialogTemplate
    :show-controls="false"
    :close-click-outside="false"
    class="dialog-avatar-and-display-name"
  >
    <h5>{{ title }}</h5>
    <AvatarEdit
      v-if="forceAvatar"
      class="avatar"
      size="small"
      :member-id="context.memberId"
      :auto-edit="false"
      @click-edit="handleClickEditAvatar"
    />
    <div
      v-if="forceDisplayName"
      class="form form-field form-field-text small form-secondary"
    >
      <label for="displayname">Pseudo</label>
      <input
        id="displayname"
        v-model="model"
        name="displayname"
        role="displayname"
        type="text"
        @keydown.enter="emit('confirm', model)"
      />
    </div>
    <template #footer>
      <DialogUiConfirm
        :enable="enableSubmit"
        :cancel="false"
        @confirm="emit('confirm', model)"
      />
    </template>
  </DialogTemplate>
</template>
<script lang="ts" setup>
interface Props {
  firstname?: string;
  forceAvatar?: boolean;
  forceDisplayName?: boolean;
}

const props = defineProps({
  firstname: { default: '' },
  forceAvatar: { type: Boolean, default: true },
  forceDisplayName: { type: Boolean, default: true }
});

const emit = defineEmits(["selectEditAvatar", "confirm"]);

const profile = useProfileStore();
const context = useContextStore();

const model = defineModel<string>({ default: '' });

onMounted(() => {
  model.value = props.firstname;
});

const title = computed(() => {
  if (props.forceDisplayName && props.forceAvatar)
    return 'Choisis ton pseudo et ton avatar !';
  if (props.forceDisplayName) return 'Choisis ton pseudo !';
  if (props.forceAvatar) return 'Choisis ton avatar !';
});

const enableSubmit = computed(() => {
  if (!model.value.length) return;
  if (model.value.length > 30) return false;
  if (props.forceAvatar && !profile.isAvatarSelected) return false;

  return true;
});

const handleClickEditAvatar = () => {
  emit('selectEditAvatar');
};
</script>
<style lang="scss" scoped>
.form {
  width: 100%;
}
</style>
